import React from "react";
import { OptionsObject, useSnackbar, ProviderContext } from "notistack";
import { ServerErrorProps } from "../components/snackbar/ServerError";

// Must be imported at least once in the app to initialize the ref
let snackbarRef: ProviderContext;
export const SnackbarUtilsConfigurator: React.FC = () => {
    snackbarRef = useSnackbar();
    return null;
};

// Export no-named default so consumer can name as desired/required
export default {
    success(msg: string, options: OptionsObject = {}): void {
        this.toast(msg, { ...options, variant: "success" });
    },
    warning(msg: string, options: OptionsObject = {}): void {
        this.toast(msg, { ...options, variant: "warning" });
    },
    info(msg: string, options: OptionsObject = {}): void {
        this.toast(msg, { ...options, variant: "info" });
    },
    error(msg: string, options: OptionsObject = {}): void {
        this.toast(msg, { ...options, variant: "error" });
    },
    serverError(msg: string, options: OptionsObject & ServerErrorProps): void {
        this.toast(msg, {
            anchorOrigin: {
                horizontal: "right",
                vertical: "top",
            },
            ...options,
            variant: "serverError",
        });
    },
    toast(msg: string, options: OptionsObject = {}): void {
        snackbarRef.enqueueSnackbar(msg, options);
    },
};
